/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [delete-friend-dialog.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 03.03.20, 18:21
 */


import React, {useState} from 'react';
import {WavesTooltipBounded} from "../../../components/navigation/buttons/nav-buttons";
import MessageBox from "../../../components/dialogs/message-box";
import {generateAvatar} from "../../../components/billboard-cover/generate-avatar";
import {useLanguage} from "../../../components/configuration/configuration";
import {PersonRemoveIcon} from "../../../components/navigation/icons/nav-icons";

const DeleteFriendDialog = (props) => {
    const Lang = useLanguage();
    const {friend, onDelete} = props;
    const [isDeleteOpen, setDeleteOpen] = useState(false);

    return <div className='delete-friend-dialog'>

        {/*<WavesTooltipBounded circle title={Lang.chat.active.delete(friend.firstname)}*/}
        {/*                     className='fas fa-user-minus' onClick={(event) => setDeleteOpen(true)}/>*/}

        <WavesTooltipBounded circle title={Lang.chat.active.delete(friend.firstname)}
                             className='generic-navigation-button mr-1'
                             onClick={(event) => setDeleteOpen(true)}>
            <PersonRemoveIcon aria-hidden="true"/>
        </WavesTooltipBounded>

        {isDeleteOpen && <MessageBox isOpen={isDeleteOpen}
                    setIsOpen={(event) => setDeleteOpen(false)}
                    title={Lang.chat.deleteDialog.title}
                    action={Lang.chat.deleteDialog.action}
                    image={friend.avatar || generateAvatar(friend.firstname, friend.lastname)}
                    callback={onDelete}>

            <div className='delete-friend-dialog-content mt-3'>
                {Lang.chat.deleteDialog.information(friend.firstname)}
                <div className='delete-post-dialog-warning mt-2'>
                    {Lang.chat.deleteDialog.warning}
                </div>
            </div>

        </MessageBox>}
    </div>
};

export default DeleteFriendDialog;

